<template lang="html">
    <div id="setupPage" class="flex md:block items-center justify-center h-screen md:h-auto bg-gray-100 dark:bg-gray-900 md:px-0 mobile-select-none" :class="isLoading ? 'px-0' : 'px-4'">
  	  <div class="bg-animated text-white flex space-y-8 flex-col h-screen w-full z-10 items-center justify-center" v-show="isLoading">
        <div class="h-32 rounded-md overflow-hidden text-center">
            <img :src="companyLogo" class="object-contain bg-gray-100 dark:bg-gray-700 aspect-square  h-full inline-flex" />
        </div>
  			<div class="text-4xl font-bold">
          Loading
  			</div>
  			<!-- Spinning semi-circle -->
  			<svg class="block animate-spin h-8 w-8 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  				<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
  				<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
  			</svg>
  		</div>	
       <div v-show="!isLoading" class="flex md:mt-0 w-full md:w-auto">
            <!-- Blue sidebar -->
            <div class="bg-blue-400 dark:bg-gray-800 text-blue-200 dark:text-gray-100 min-h-screen hidden sm:block sm:w-1/3 lg:w-128 px-8 lg:pl-24 py-20">
            <!-- MicTap Mirror logo -->
                <img :src="logo" class="w-1/2" />
                <div class="font-medium mt-10 relative" :class="currentStep == 1 ? 'text-white' : ''">
                    <h2 class="text-lg">
                        1. Allow access to your microphone
                    </h2>
                    <p class="mt-2 font-light lg:w-64">
                        We need access to your microphone to be able to share your voice with the world.
                    </p>
                <div class="step_indicator absolute right-0 top-0 bg-white dark:bg-gray-900 text-blue-500 dark:text-white font-bold w-10 h-10 text-xl rounded-full mt-4 -mr-14 flex items-center justify-center"
                        :class="currentStep > 1 ? 'completed' : currentStep == 1 ? 'actual' : ''">
                        1
                </div>
                </div>
                <div class="font-medium mt-10 relative"  :class="currentStep == 2 ? 'text-white' : ''">
                    <h2 class="text-lg">
                    2. Enter your name
                    </h2>
                    <p class="mt-2 font-light lg:w-64">
                        Your name will be shown to all participants in the session and with the host.
                    </p>
                <div class="step_indicator absolute right-0 top-0 bg-white dark:bg-gray-900 text-blue-500 dark:text-white font-bold w-10 h-10 text-xl rounded-full mt-4 -mr-14 flex items-center justify-center"
                        :class="currentStep > 2 ? 'completed' : currentStep == 2 ? 'actual' : ''">
                        2
                </div>
                </div>
                <div class="font-medium mt-10 relative"  :class="currentStep == 3 ? 'text-white' : ''">
                    <h2 class="text-lg">
                    3. Test your microphone and headphones
                    </h2>
                    <p class="mt-2 font-light lg:w-64">
                        We use a Hold-to-talk button to keep the session organized.
                    </p>
                <div class="step_indicator absolute right-0 top-0 bg-white dark:bg-gray-900 text-blue-500 dark:text-white font-bold w-10 h-10 text-xl rounded-full mt-4 -mr-14 flex items-center justify-center"
                        :class="currentStep > 4 ? 'completed' : currentStep == 3 ? 'actual' : ''">
                        3
                </div>
                </div>
            </div>
            <!-- Main content -->
            <div class="bg-gray-100 dark:bg-gray-900 w-full sm:w-2/3 lg:w-full mt-16 sm:mt-0 flex items-center justify-center">
                <div class="bg-white dark:bg-gray-800 rounded-lg w-full max-w-lg shadow-lg" id="modal">
                    <div class="-mt-16 h-32 rounded-md overflow-hidden text-center">
                        <img :src="companyLogo" class="object-contain bg-gray-100 dark:bg-gray-700 aspect-square  h-full inline-flex" />
                    </div>
                    <div class="w-full pt-8 pb-4 sm:py-8 px-4 sm:px-12 text-center">
                        <!-- Step 0 -->
                        <div v-show="currentStep == 0">
                            <h1 class="font-medium text-2xl">
                                Welcome to MicTap <span class="capitalize">{{product_name}}.</span>
                            </h1>
                            <p class="text-gray-700 dark:text-gray-100 mt-8 text-base">
                            In order to join we must set up some things first. <br />
                            Don't worry; it will only take a minute.
                            </p>
                        </div>
                        <!-- Step 1 -->
                        <div v-show="currentStep == 1">
                            <h1 class="font-medium text-2xl">
                                Allow access to your microphone
                            </h1>
                            <div v-if="!deniedPermissions">
                                <p class="text-gray-700 dark:text-gray-100 mt-8 text-ba" v-if="!allowedPermissions">
                                    We need access to your microphone to be able to share your voice with the world.
                                </p>
                                <div class="text-gray-700 dark:text-gray-100 mt-8" v-show="allowedPermissions">
                                    <div class="w-12 p-2 rounded-full bg-green-800 mx-auto mb-8">
                                        <!-- Check icon -->
                                        <svg class="h-8 w-8 text-white" fill="currentColor" viewBox="0 0 20 20" stroke="currentColor">
                                        <path d="M8.294 16.998c-.435 0-.847-.203-1.111-.553L3.61 11.724a1.392 1.392 0 0 1 .27-1.951 1.392 1.392 0 0 1 1.953.27l2.351 3.104 5.911-9.492a1.396 1.396 0 0 1 1.921-.445c.653.406.854 1.266.446 1.92L9.478 16.34a1.39 1.39 0 0 1-1.12.656c-.022.002-.042.002-.064.002z"/>
                                        </svg>
                                    </div>
                                    <p>
                                    You have already granted the permissions to use your microphone.
                                    </p>
                                </div>
                                <button @click='allowMicrophone' class="btn btn-primary mt-8 hidden" id="allowMicrophoneButton">Grant access to my microphone</button>
                            </div>
                            <div class="text-red-600 text-lg mt-4" v-else-if="deniedPermissions">
                                Oh no! You have denied permissions to use your microphone. Please, go to your browser settings and enable it back again.
                            </div>
                        </div>
                        <!-- Step 2 -->
                        <div v-show="currentStep == 2">
                            <h1 class="font-medium text-2xl">
                            Enter your name
                            </h1>
                            <p class="text-gray-700 dark:text-gray-100 mt-8 text-base">
                                Your name will be shown to all participants in the session.
                            </p>
                            <div class="flex space-x-1 mt-5 sm:m-8">
                              <div class="relative w-full">
                                <input id="setupNameInput" type="text" class="form-input" maxlength="18" v-model="userName">
                                <div class="h-full right-3 absolute z-10 inset-y-0 dark:text-blue-100 text-blue-700 text-sm pt-3">{{ userName.length }}/18</div> 
                              </div> 
                            </div>
                        </div>
                        <!-- Step 3 -->
                        <div v-show="currentStep == 3">
                            <h1 class="text-2xl font-medium">
                                Test your microphone and headphones/speakers
                            </h1>
                            <p class="text-gray-700 dark:text-gray-100 mt-4 sm:mt-10 text-base">
                                Press and hold the <b>Hold-to-talk</b> button and say:
                            </p>
                            <div class="font-bold text-black dark:text-white text-lg py-4">
                                {{ randomPhrase }}
                            </div>
                            <p class="text-gray-700 dark:text-gray-100 text-base">
                                Release the button, if you hear it back you are all set.
                            </p>
                            <button type="button" class="mt-6 mx-auto rounded-xl md:rounded-md py-2 text-center cursor-pointer btn btn-primary w-64 ptt h-20 sm:h-16 lg:h-14 flex justify-center items-center select-none" id="recordAudioButton">
                              <div class="waiting-to-speak">
                                <div class="inline-flex items-center space-x-2">
                                  <!-- Microphone icon -->
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 sm:w-5 h-5 sm:h-5 -ml-1">
                                    <path d="M8.25 4.5a3.75 3.75 0 117.5 0v8.25a3.75 3.75 0 11-7.5 0V4.5z" />
                                    <path d="M6 10.5a.75.75 0 01.75.75v1.5a5.25 5.25 0 1010.5 0v-1.5a.75.75 0 011.5 0v1.5a6.751 6.751 0 01-6 6.709v2.291h3a.75.75 0 010 1.5h-7.5a.75.75 0 010-1.5h3v-2.291a6.751 6.751 0 01-6-6.709v-1.5A.75.75 0 016 10.5z" />
                                  </svg>
                                  <div class="text-2xl sm:text-base font-bold"> Hold-to-talk </div>
                                </div>
                                <div class="sm:block hidden -mt-1"> or press the spacebar</div>
                              </div>
                              <div class="now-speaking py-3">
                                <div class="font-bold">Speak now</div>
                              </div>
                              <div class="playing hidden">
                                  <div class="font-bold">Playing back your recording</div>
                              </div>
                            </button>
                            <!-- Some error message container -->
                            <span id="errorMsg" class="mt-4">
                                <span v-show="!supportsRecording">
                                Doesn't support recording
                                </span>
                            </span>
                        </div>
                    <button id="nextStepButton" type="button" class="btn w-full sm:w-auto mt-14 sm:mt-10" :class="validStep ? 'btn-primary' : 'btn-disabled'" :disabled="!validStep" @click="nextStep">
                        Continue
                    </button>
                    <button class="btn w-full sm:w-auto mt-14 sm:mt-10 btn-danger hidden" @click="currentStep = 3; nextStep()">
                        Skip
                    </button>
                    </div>
                </div>
            </div> <!-- end of modal -->
        </div>
        <audio id="test_recording"></audio>
    </div>
</template>
<script>

import { detectBrowser } from 'utils/browser';


export default {
  props: {
    logo: {},
    arrow: {},
    participantName: {},
    roomKey: {},
    companyLogo: {},
    safariEnabled: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {
      userName: '',
      currentStep: -1,
      supportsRecording: true,
      maxRecordingTime: 5000, // in milliseconds
      started: false,

      allowedBrowsers: {
        'chrome': 81,
        // 'firefox': 81,
      },

      browser: {},
      allowedPermissions: false,
      deniedPermissions: false,

      // for recording (step 3)
      mediaRecorder: null,
      recordingStream: null,

      product: product,
      product_name: product,
      recordedStream: false,
      isLoading: true,
    }
  },
  methods: {
    nextStep(){
      this.currentStep += 1;
      switch(this.currentStep){
      case 0:
        this.checkBrowser();
        break;
      case 1:
		    this.checkPermissions();
        window.setTimeout(()=>{
          document.querySelector("#allowMicrophoneButton").focus();
        } , 1000)

        break;
      case 2:
        // setup next step
        // load name from local storage
        const savedName = localStorage.getItem("mictapName");
        if(savedName !== null && savedName.length > 0 && savedName != "undefined")
          this.userName = savedName;
        console.log("Getting name ")
        window.setTimeout(()=>{
          document.querySelector("#setupNameInput").focus()
        } , 1000)
        break;
      case 3:
        this.saveName();
        startSoundMeterContext();
        // setup next step
        this.setRecordingListeners()
        this.supportsRecording = this.supportsRecordingMethod('audio/webm')
        // Note: safari only supports mp4
        if(this.supportsRecording == false){
          // if the browser doesnt support recording then skip the test
          this.nextStep();
        }
        break;
      }
      if (this.currentStep == 4) {
        // walktrough is over.
        this.startSession()
      }
    },
    startSession(){
		    this.removeRecordingListeners();
        if (this.started){ return };
        this.started = true;
        setupEngine(product, role, this.userName, participant_key, room_key)
        window.setTimeout(() => {
          window.resizeVideo()
        }, 1000)

        $("#setupPage").slideUp();
        $("#body").slideDown()
        if (this.roomKey) {
          window.roomKey = this.roomKey;
          // joinSession(this.roomKey);
        }
        // $("#tutorialOverlay").slideDown();
        // mute myself
        $("#tutorialOverlay1").toggleClass("lg:block xl:block 2xl:block ")
        $("#tutorialOverlay2").toggleClass(" hidden block sm:block md:block ")

        setTimeout(function(){   $("#tutorialOverlay1").addClass("lg:hidden xl:hidden 2xl:hidden ")
                                 $("#tutorialOverlay2").addClass(" hidden sm:hidden md:hidden")
                                 $("#guide").removeClass("hidden"); }, 10000);

    },
    // step 0
    checkBrowser(){
      const browser = detectBrowser(window);
      this.browser = browser;
      if( this.allowedBrowsers[browser.browser] <= browser.version){
        // do something only for allowed browsers
        //  this.nextStep();
      }
      else{
        $("#browserNotCompatible").removeClass("hidden")
        $("#browserName").html(browser.browser + " " + browser.version)
      }
    },
    // step 1
	  checkPermissions(){
      if (!navigator.permissions || this.browser.browser !== 'chrome') {
        return this.checkMediaAccess('prompt');
      };
      navigator.permissions.query({ name: 'microphone' })
               .then((permissionStatus) => {                 // then return a promise(2 argumentes) success and fail
                 this.checkMediaAccess(permissionStatus.state)
                 permissionStatus.onchange = () => {                    //Function that change permission   onchange: ((this: PermissionStatus, ev: Event) => any) | null;
                   this.checkMediaAccess(permissionStatus.state)
                 }
               })
    },
	  checkMediaAccess(state){                     //Estado de los permisos
      switch(state){
      case 'granted':
        this.allowedPermissions = true;
        this.getRecordingStream();
        $("#allowMicrophoneButton").addClass("hidden");

          this.nextStep();
        window.setTimeout(()=>{
          document.querySelector("#nextStepButton").focus()
        } , 1000)

        break;
      case 'denied':
        this.deniedPermissions = true;
        break;
      case 'prompt':
        this.allowedPermissions = false;
        $("#allowMicrophoneButton").removeClass("hidden");
        break;
      }
    },
    getRecordingStream(){
      try{
        navigator.mediaDevices.getUserMedia({audio:  true})
                 .then(newStream =>{
                   // This is necesary for Safari
                   if (this.browser.browser == 'safari') {
                      this.nextStep();
                   }
                   this.allowedPermissions = true;
                   $("#allowMicrophoneButton").addClass("hidden");

                   this.recordingStream = newStream;
                   this.setRecordingListeners();
                 })
      }catch(e){
        this.deniedPermissions = true;
        console.error(e)
      }
    },
    allowMicrophone() {
      // start a timeout that will hide the media-access message and prompt again for access?
      window.setTimeout(()=>{
        if (this.allowedPermissions == true) return;
      } , 10000)
      this.getRecordingStream();
    },
    // step 3
    mouseDown(){
      var options = { mimeType: "audio/webm" };
      this.mediaRecorder = new MediaRecorder(this.recordingStream, options);
      this.mediaRecorder.ondataavailable = this.handleDataAvailable;
      // set timeout for maxrecordingtime
      this.mediaRecorder.start();
      window.setTimeout(()=>{
        this.mouseUp();
      }, this.maxRecordingTime)
      $("#recordAudioButton").addClass("speaking")
    },
    mouseUp(){
      $("#recordAudioButton").removeClass("speaking")
      if (this.mediaRecorder){
        this.mediaRecorder.stop();
      }
    },
    keydown(e){
      if(e.which === 32 && e.repeat === false ){
        if ($('input').is(':focus')) return;

        e.preventDefault();
        this.mouseDown();
      }
    },
    keyup(e){
      if(e.which === 32){
        this.mouseUp();
      }
    },

    setRecordingListeners(){
      // keyboard listeners
      document.body.addEventListener("keydown", this.keydown)
      document.body.addEventListener("keyup", this.keyup)

      // set click listeners
      let recordAudioButton = document.getElementById("recordAudioButton");
      if (recordAudioButton == null) return;
      recordAudioButton.addEventListener("mousedown", this.mouseDown);
      recordAudioButton.addEventListener("touchstart", this.mouseDown);
      recordAudioButton.addEventListener("mouseup", this.mouseUp);
      recordAudioButton.addEventListener("touchend", this.mouseUp);
    },

    removeRecordingListeners(){
      let recordAudioButton = document.getElementById("recordAudioButton");
      if (recordAudioButton == null) return;
      // click listeners
      recordAudioButton.removeEventListener("mousedown", this.mouseDown, false);
      recordAudioButton.removeEventListener("touchstart", this.mouseDown, false);
      recordAudioButton.removeEventListener("mouseup", this.mouseUp, false);
      recordAudioButton.removeEventListener("touchend", this.mouseUp, false);

      document.body.removeEventListener('keydown', this.keydown, false)
      document.body.removeEventListener('keyup', this.keyup, false)
      // We dont need this stream any longer, lets stop it
      if (this.recordingStream == null) {
        console.warn("Didnt remove recording listeners because recordingStream is null")
        return
      };
      this.recordingStream.getTracks().forEach((t)=>{ t.stop() })
    },

    // funcion para resetear el texto
    resetRecordButton(){
      $("#recordAudioButton .playing").addClass("hidden")
      $("#recordAudioButton .waiting-to-speak").removeClass("hidden")

    },

    handleDataAvailable(event) {
      if (event.data.size > 0) {
        //crear player
        const player = document.getElementById('test_recording')
        player.onended = this.resetRecordButton
        document.body.appendChild(player)
        // asignar data a player
        const options = { type: "audio/webm" };
        const blob = new Blob([event.data], options)

        const mediaURL = window.URL.createObjectURL(blob)
        player.src = mediaURL;
        // reproducir

        try{
          player.play();
          $("#recordAudioButton .waiting-to-speak").addClass("hidden")
          $("#recordAudioButton .playing").removeClass("hidden")

        } catch{
          console.error("Error playing back the recording...continuing")
        }
        this.mediaRecorder = null;
        this.recordedStream = true;
      } else {
        // ...
      }
    },

    supportsRecordingMethod(mimeType){
      if (!window.MediaRecorder){
        console.log("MediaRecorder doesnt exist");
        return false;
      }
      if (!MediaRecorder.isTypeSupported)
        return mimeType.startsWith("audio/mp4") || mimeType.startsWith("video/mp4");
      return MediaRecorder.isTypeSupported(mimeType);
    },
    saveName(){
      $(".userName").html(this.userName);
      window.name = this.userName;
      localStorage.setItem("mictapName", this.userName);
    },

    randomItemInArray(array){
      return array[parseInt(Math.random() * array.length - 1)];
    },

    siglasFromName(name){
      return name.trim().split(" ").map(a => a[0].toUpperCase()).join("").slice(0,2)
    }
  },
  computed:{
    validStep(){
      switch(this.currentStep){
      case 0:
        return true;
        break;
      case 1:
        return this.allowedPermissions;
        break;
      case 2:
        return this.userName.length >= 2; // minimum 2 characters
        break;
      case 3:
        return this.recordedStream;
        break
      default:
        return true;
        break;
      }

      return true
    },
    randomPhrase(){
      var adjectives = ["Happy", 'Sad', 'Fast', 'Messy', 'Funny', 'Small', 'Silly']
      var adjective_2 = ["Coolest", 'Upbeat', 'Great', 'Negligent', 'Clingy', 'Talking', 'Smiling', 'Grumpy']
      var noun = ['Table', 'Dog', 'Cat', 'Octopus', 'Cartoon', 'Hat']
      return this.randomItemInArray(adjectives) + " " + this.randomItemInArray(adjective_2) + " " + this.randomItemInArray(noun);
    }
  },
  mounted() {
    // when the dom is done loading set the loading to false
    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        this.isLoading = false;
      }
    };

    if(this.safariEnabled){
      this.allowedBrowsers['safari'] = 605
    }
    if (this.product == "mirror_shoot") this.product_name = "Mirror"

    this.userName = this.participantName;
    this.nextStep();
    const skipSteps = new URLSearchParams(window.location.search).get('skip');
    if (skipSteps == "1") {
      // this.currentStep = parseInt(skipSteps);
      // this.nextStep();
      this.startSession();
    }
  }
}
</script>
<style lang="css">
.completed {
	color: white!important;
	background-color: #4a4949!important;
}
.dark .completed{
	color: white!important;
	background-color: black!important;
}
</style>
